import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "middle_title" }
const _hoisted_3 = { class: "tip" }

import { useUserStore } from '@/stores/user'
import { ref } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'logoutPopup',
  setup(__props, { expose: __expose }) {

const show = ref(false)
const userStore = useUserStore()
const open = () => {
    show.value = true
}

const close = () => {
    show.value = false
}
const logOut = () => {
    userStore.signOut()
    sessionStorage.setItem('openPromotionPopup', '');
}
__expose({
    open,
})


return (_ctx: any,_cache: any) => {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    position: "bottom",
    style: {
        width: '100%',
        minHeight: '40%',
        borderTopLeftRadius: '15px',
        borderTopRightRadius: '15px',
        background: 'linear-gradient(rgb(159, 51, 132), rgb(62, 45, 76))',
        zIndex: '10001'
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('profile.logoutCurrAcc')), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('profile.rememberPassword')), 1),
        _createElementVNode("div", {
          class: "loagout_btn",
          onClick: logOut
        }, _toDisplayString(_ctx.$t('profile.toLogout')), 1),
        _createElementVNode("div", {
          class: "cancel_btn",
          onClick: close
        }, _toDisplayString(_ctx.$t('profile.cancel')), 1)
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})